import React from "react";
import injectSheet from "react-jss";

const styles = ({ theme }) => {
  return {
    descriptionListHeader: {
      display: "flex",
      fontFamily: theme.fonts.swedbankHeadlineBlack,
      fontWeight: theme.fontWeights.bold,
      alignItems: "center",
      borderBottom: `2px solid #d4b8a3`,
      fontSize: theme.textSizes["6"],
      color: theme.colors.tertiary1,
      //   backgroundColor: ({ zebra, themeId }) =>
      //     themeId
      //       ? themeProperties[themeId].background
      //       : zebra
      //       ? theme.colors.quinary1
      //       : null,
      //   color: ({ zebra }) => (zebra ? theme.colors.senary1 : "inherit"),
      padding: ({ zebra, themeId }) => (zebra || themeId ? 15 : null)
    },
    rightContent: {
      marginLeft: "auto"
    }
  };
};

const DescriptionListHeader = ({ children, classes }) => {
  const childrenArray = React.Children.toArray(children);
  const otherChildren = childrenArray.splice(1);

  return (
    <header className={classes.descriptionListHeader}>
      {/* the first child to the left*/}
      {childrenArray[0]}
      {/* the following children to the right*/}
      {otherChildren.length > 0 && (
        <div className={classes.rightContent}>{otherChildren}</div>
      )}
    </header>
  );
};

export default injectSheet(styles, { inject: ["classes"] })(
  DescriptionListHeader
);
